// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"root_spinner-module__spinnerWrapper___DQ5Kj"};